import VueGoogleMaps from '@fawmi/vue-google-maps';

import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import VueScrollTo from 'vue-scrollto';
import smoothscroll from 'smoothscroll-polyfill';
import VueGtag from 'vue-gtag';

import App from '@/App.vue';
import Go from '@/components/utils/Go.vue';
import Image from '@/components/utils/Image.vue';

import store from './store';
import checkView from './utils/vue-check-view';
import focusDirective from './directives/focus';

import './assets/styles/main.scss';

// polyfills
// --------------------------------
smoothscroll.polyfill();

// app
// --------------------------------
const app = createApp(App);

const head = createHead();
app.use(head);
app.use(store);
app.use(VueScrollTo);
app.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAO9O4G5UDmxqX6gP1pdi9SrquKkmGS2nk',
  },
});
app.use(VueGtag, {
  bootstrap: false,
  config: { id: 'G-Q0VCHB669P' },
});

app.use(checkView, { insideThreshold: () => (window.innerWidth < 960 ? 0.1 : 0.15) });

window.getPath = () => window.location.pathname.replace(/\/$/, '');

// i18n
// --------------------------------

// custom components
// --------------------------------
app.component('Go', Go);
app.component('Image', Image);

app.directive('focus', focusDirective);

app.mount('#app');
if (!window.prerender) setTimeout(() => window.document.body.classList.remove('no-anim'), 100);
